// // public/src/pages/Contact.jsx
// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { FiMail, FiPhone, FiMapPin, FiSend } from 'react-icons/fi';
// import axios from 'axios';
// import '../styles/contact.css';

// function Contact() {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     company: '',
//     service: '',
//     budget: '',
//     message: ''
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitStatus, setSubmitStatus] = useState(null);

//   const services = [
//     'Precision Farming',
//     'IoT Solutions',
//     'Data Analytics',
//     'Drone Technology',
//     'Smart Irrigation',
//     'Crop Monitoring',
//     'Soil Analysis',
//     'Consulting'
//   ];

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     setSubmitStatus(null);

//     try {
//       const response = await axios.post('https://agri-back-mauve.vercel.app/api/contacts', formData);

//       if (response.data.success) {
//         setSubmitStatus({ type: 'success', message: response.data.message });
//         setFormData({
//           name: '',
//           email: '',
//           phone: '',
//           company: '',
//           service: '',
//           budget: '',
//           message: ''
//         });
//       }
//     } catch (error) {
//       setSubmitStatus({
//         type: 'error',
//         message: error.response?.data?.message || 'Failed to send message'
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="contact-page">
//       {/* Hero Section */}
//       <section className="page-hero">
//         <div className="container">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="hero-content"
//           >
//             <h1>Get In Touch</h1>
//             <p>Ready to transform your agricultural operations? Let's discuss how our technology solutions can help you achieve better results.</p>
//           </motion.div>
//         </div>
//       </section>

//       <div className="container">
//         <div className="contact-content">
//           {/* Contact Info */}
//           <motion.div
//             initial={{ opacity: 0, x: -50 }}
//             animate={{ opacity: 1, x: 0 }}
//             className="contact-info"
//           >
//             <h2>Let's Start a Conversation</h2>
//             <p>We're here to help you implement cutting-edge agricultural technology solutions.</p>

//             <div className="contact-methods">
//               <div className="contact-method">
//                 <div className="method-icon">
//                   <FiMail />
//                 </div>
//                 <div>
//                   <h4>Email Us</h4>
//                   <p>sooikeh@afrikonsults.com</p>
//                 </div>
//               </div>

//               <div className="contact-method">
//                 <div className="method-icon">
//                   <FiPhone />
//                 </div>
//                 <div>
//                   <h4>Call Us</h4>
//                   <p>+234-8181184913 </p>
//                   <p> +234-8081081048 </p>

//                   <p> +234-8137259396</p>

//                 </div>
//               </div>

//               <div className="contact-method">
//                 <div className="method-icon">
//                   <FiMapPin />
//                 </div>
//                 <div>
//                   <h4>Visit Us</h4>
//                   <p>Lagos State, Nigeria</p>
//                   <p>Plot 192, AI Close; Federal Lowcost Housing Estate, Ikorodu, Lagos State
// </p>
//                 </div>
//               </div>
//             </div>

//             <div className="office-hours">
//               <h4>Office Hours</h4>
//               <p>Monday - Friday: 8:00 AM - 6:00 PM</p>
//               <p>Saturday: 9:00 AM - 2:00 PM</p>
//             </div>
//           </motion.div>

//           {/* Contact Form */}
//           <motion.div
//             initial={{ opacity: 0, x: 50 }}
//             animate={{ opacity: 1, x: 0 }}
//             className="contact-form-container"
//           >
//             <form onSubmit={handleSubmit} className="contact-form">
//               {submitStatus && (
//                 <div className={`alert ${submitStatus.type}`}>
//                   {submitStatus.message}
//                 </div>
//               )}

//               <div className="form-row">
//                 <div className="form-group">
//                   <label htmlFor="name">Full Name *</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="email">Email Address *</label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="form-row">
//                 <div className="form-group">
//                   <label htmlFor="phone">Phone Number</label>
//                   <input
//                     type="tel"
//                     id="phone"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="company">Company/Farm</label>
//                   <input
//                     type="text"
//                     id="company"
//                     name="company"
//                     value={formData.company}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               <div className="form-row">
//                 <div className="form-group">
//                   <label htmlFor="service">Service Interested In *</label>
//                   <select
//                     id="service"
//                     name="service"
//                     value={formData.service}
//                     onChange={handleChange}
//                     required
//                   >
//                     <option value="">Select a service</option>
//                     {services.map(service => (
//                       <option key={service} value={service}>{service}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="budget">Budget Range</label>
//                   <select
//                     id="budget"
//                     name="budget"
//                     value={formData.budget}
//                     onChange={handleChange}
//                   >
//                     <option value="">Select budget</option>
//                     <option value="Under $5,000">Under $5,000</option>
//                     <option value="$5,000 - $15,000">$5,000 - $15,000</option>
//                     <option value="$15,000 - $50,000">$15,000 - $50,000</option>
//                     <option value="Over $50,000">Over $50,000</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label htmlFor="message">Project Details *</label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   rows="6"
//                   value={formData.message}
//                   onChange={handleChange}
//                   placeholder="Tell us about your project, challenges, and goals..."
//                   required
//                 ></textarea>
//               </div>

//               <button
//                 type="submit"
//                 className="submit-button"
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting ? (
//                   <>Sending...</>
//                 ) : (
//                   <>
//                     <FiSend />
//                     Send Message
//                   </>
//                 )}
//               </button>
//             </form>
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Contact;

import React, { useState } from "react";
import { motion } from "framer-motion";
import { FiMail, FiPhone, FiMapPin, FiSend, FiGlobe } from "react-icons/fi";
import axios from "axios";
import "../styles/contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    service: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const services = [
    "Precision Farming",
    "IoT Solutions",
    "Data Analytics",
    "Drone Technology",
    "Smart Irrigation",
    "Crop Monitoring",
    "Soil Analysis",
    "Consulting",
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await axios.post(
        "https://agri-back-mauve.vercel.app/api/contacts",
        formData
      );

      if (response.data.success) {
        setSubmitStatus({ type: "success", message: response.data.message });
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          service: "",
          message: "",
        });
      }
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message: error.response?.data?.message || "Failed to send message",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="hero-content"
          >
            <h1>Get In Touch</h1>
            <p>
              Ready to transform your agricultural operations? Let's discuss how
              our technology solutions can help you achieve better results.
            </p>
          </motion.div>
        </div>
      </section>

      <div className="container">
        <div className="contact-content">
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            className="contact-info"
          >
            <h2>Let's Start a Conversation</h2>
            <p>
              We're here to help you implement cutting-edge agricultural
              technology solutions.
            </p>

            <div className="contact-methods">
              <div className="contact-method">
                <div className="method-icon">
                  <FiMail />
                </div>
                <div>
                  <h4>Email Us</h4>
                  <p>sooikeh@afrikonsults.com</p>
                </div>
              </div>

              {/* Call Us Section - Split by Country */}
              <div className="contact-method">
                <div className="method-icon">
                  <FiPhone />
                </div>
                <div>
                  <h4>Call Us - Nigeria</h4>
                  <p>+234-7063330321</p>
                  <p>+234-7053330325</p>
                  <p>+234-8161184913</p>
                  

                  <h4 style={{ marginTop: "15px" }}>Call Us - Kenya</h4>
                  <p>+254-712205453</p>
                  <p>+234-8161184913</p>
                </div>
              </div>

              {/* Visit Us Section - Split by Country */}
              <div className="contact-method">
                <div className="method-icon">
                  <FiMapPin />
                </div>
                <div>
                  <h4>Visit Us - Nigeria</h4>
                  <p>Zaria, Nigeria</p>
                  <p>7, Area G, Staff Quarters, Samaru</p>

                  <h4 style={{ marginTop: "15px" }}>Visit Us - Kenya</h4>
                  <p>Nairobi, Lavington Road</p>
                  <p>Leo Residence, Apt B2-2, Hatheru</p>
                </div>
              </div>

              {/* Regional Coverage */}
              <div className="contact-method">
                <div className="method-icon">
                  <FiGlobe />
                </div>
                <div>
                  <h4>Regional Coverage</h4>
                  <p>
                    <strong>Nigeria Office:</strong> West and Central Africa Region
                  </p>
                  <p>
                    <strong>Kenya Office:</strong> East and Southern Africa Region
                  </p>
                </div>
              </div>
            </div>

            <div className="office-hours">
              <h4>Office Hours</h4>
              <p>Monday - Friday: 8:00 AM - 6:00 PM</p>
              <p>Saturday: 9:00 AM - 2:00 PM</p>
              <p>
                <em>Both Nigeria and Kenya offices follow these hours</em>
              </p>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            className="contact-form-container"
          >
            <form onSubmit={handleSubmit} className="contact-form">
              {submitStatus && (
                <div className={`alert ${submitStatus.type}`}>
                  {submitStatus.message}
                </div>
              )}

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="company">Company/Farm</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="service">Service Interested In *</label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a service</option>
                  {services.map((service) => (
                    <option key={service} value={service}>
                      {service}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Project Details *</label>
                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your project, challenges, and goals..."
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>Sending...</>
                ) : (
                  <>
                    <FiSend />
                    Send Message
                  </>
                )}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
